import React from 'react';
import PhoneInput, {
  isValidPhoneNumber,
  getCountries,
  getCountryCallingCode,
} from 'react-phone-number-input';
import flags from 'react-phone-number-input/flags';
import 'react-phone-number-input/style.css';
import _ from 'lodash';
import './index.css';

class PhoneNumberInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      phoneNumber: props.value,
    };

    // Debounce the handleChangeValue method
    this.debouncedHandleChangeValue = _.debounce(this.handleChangeValue, 600);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let phoneNumber = nextProps.value;
    if (phoneNumber && !String(phoneNumber).startsWith('+')) {
      const defaultCountryCode = getCountryCallingCode(process.env.REACT_APP_COUNTRY || 'LB');
      phoneNumber = `+${defaultCountryCode}${phoneNumber}`;
    }

    return {
      phoneNumber: phoneNumber,
    };
  }

  componentWillUnmount() {
    // Cancel any pending debounced calls to prevent memory leaks
    this.debouncedHandleChangeValue.cancel();
  }

  handleChangeValue = (new_value) => {
    let is_valid_new_value = true;

    if(new_value !== '' && new_value !== undefined && new_value !== null && !isValidPhoneNumber(new_value)) {
      is_valid_new_value = false;
    }
    this.props.handleAddValidationErrorChange(
      this.props.name,
      is_valid_new_value ? null : 'Phone number format is invalid.',
    );

    this.setState({ phoneNumber: new_value });
    this.props.handleChange(this.props.name, new_value);
  }

  handleInputChange = (new_value) => {
    if (new_value === '') {
      // If input is cleared, update state immediately
      this.handleChangeValue(new_value);
    } else {
      // Otherwise, use the debounced version
      this.debouncedHandleChangeValue(new_value);
    }
  };

  render() {
    const { name, label_text, errorText } = this.props;
    const { phoneNumber } = this.state;
    let country_list = getCountries().filter((item) => item !== 'IL');

    return (
      <div className={errorText ? 'phone_number_error' : ''}>
        {label_text && (
          <label htmlFor={name} className="react-phone-number-label2">
            {label_text}
          </label>
        )}
        <PhoneInput
          international
          id={name}
          placeholder="+000 00 000 0000"
          defaultCountry={process.env.REACT_APP_COUNTRY ? process.env.REACT_APP_COUNTRY : 'LB'}
          value={phoneNumber || ''}
          onChange={this.handleInputChange}
          countries={country_list}
          flags={flags}
          disabled={this.props.disabled}
        />
        {errorText && (
          <div className={'phone_number_error_msg'}>{errorText}</div>
        )}
      </div>
    );
  }
}

export default PhoneNumberInput;
